import { parseToJsonTextAndTags } from '@/services/forms/tmTiptap/utils/parseToJsonTextAndTags'

import { tagAttributeValue } from '@/services/forms/tmTiptap/const'

export const textToJsonTextAndTags = (text: string, isJsonContent = false) =>
  parseToJsonTextAndTags(text, isJsonContent).map(({ type, value }) =>
    type === 'text' ? { type, text: value } : { type, attrs: { [tagAttributeValue]: value } },
  )
